import styled from "styled-components";

export const defaultTerms = {
  "CELL FREE DNA": "cdn",
  "PRENATAL TESTING": "pnt",
  "NEWBORN SCREENING": "ns",
  ANEUPLOIDY: "anp",
  "NON-INVASIVE PRENATAL TESTING": "npnt"
};

export const sortOptions = [
  { value: "name", label: "Name" },
  { value: "clinical_trials_count", label: "Total Related Clinical Trials" },
  { value: "medical_bodies_count", label: "Medical Societies" },
  { value: "conference_count", label: "Conferences" },
  { value: "grants", label: "Grants" },
  { label: "CELL FREE DNA Related Trials", value: "cdn_trials_count" },
  { label: "PRENATAL TESTING Related Trials", value: "pnt_trials_count" },
  { label: "NEWBORN SCREENING Related Trials", value: "ns_trials_count" },
  { label: "ANEUPLOIDY Related Trials", value: "anp_trials_count" },
  {
    label: "NON-INVASIVE PRENATAL TESTING Related Trials",
    value: "npnt_trials_count"
  },
  { label: "CELL FREE DNA Related Articles", value: "cdn_articles_count" },
  { label: "PRENATAL TESTING Related Articles", value: "pnt_articles_count" },
  { label: "NEWBORN SCREENING Related Articles", value: "ns_articles_count" },
  { label: "ANEUPLOIDY Related Articles", value: "anp_articles_count" },
  {
    label: "NON-INVASIVE PRENATAL TESTING Related Articles",
    value: "npnt_articles_count"
  },
  { label: "CELL FREE DNA Related Citation", value: "cdn_citation_count" },
  { label: "PRENATAL TESTING Related Citation", value: "pnt_citation_count" },
  { label: "NEWBORN SCREENING Related Citation", value: "ns_citation_count" },
  { label: "ANEUPLOIDY Related Citation", value: "anp_citation_count" },
  {
    label: "NON-INVASIVE PRENATAL TESTING Related Citation",
    value: "npnt_citation_count"
  }
];

export const PaginationWrapper = styled.div`
  padding-top: 5px;
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #eef5fb;
  text-align: center;
  left: 0;
  background: rgba(255, 255, 255, 0.8);
  font-size: 11px;
`;

export const subNavBarItems = [
  {
    name: "EXPERTS",
    link: "/niptapp-experts",
    icon: "fa fa-user-alt"
  },
  {
    name: "AFFILIATIONS",
    link: "/niptapp-institutes",
    icon: "fa fa-university"
  },
  {
    name: "LOCATIONS",
    link: "/niptapp-locations-summary",
    icon: "fa fa-map-marker"
  }
];

export const topNavItems = [
  {
    link: "/niptapp-summary",
    name: "Topic Overview"
  },
  {
    link: "/niptapp-experts",
    name: "Selected Experts"
  },

  {
    link: "/niptapp-trials",
    name: "Clinical Trials"
  },

  {
    link: "/niptapp-conf",
    name: "Conferences"
  },
  {
    link: "/niptapp-medical-bodies",
    name: "Societies & Patient Groups"
  },

  {
    link: "/niptapp-collaborator-network",
    name: "Topic Network"
  },
  {
    link: "/niptapp-funding-org",
    name: "Funding Organisations"
  },
  {
    link: "",
    name: "Referral Networks",
    isNotClck: true
  },
  {
    link: "",
    name: "News",
    isNotClck: true
  }
];

export const listTypes = [
  { value: "FINAL_LIST", label: "FINAL LIST" },
  { value: "LONG_LIST", label: "LONG LIST" },
  { value: "PERSONAL_LIST", label: "PERSONAL LIST" },
  { value: "SHORT_LIST", label: "SHORT LIST" }
];

export const saveTypes = {
  SHORT_LIST: "shortList",
  PERSONAL_LIST: "personalList",
  FINAL_LIST: "selectedList"
};

export const defaultTermsTrials = {};

export const defaultKeywords = ``;

export const defaultFilters = {
  year: "",
  location: [],
  topic: [],
  affs: [],
  experts: [],
  advBoard: "",
  isActive: "",
  advanceSort: [],
  listType: {
    label: "SHORT LIST",
    value: "SHORT_LIST"
  },
  isActive: {},
  operator: { value: "OR", label: "OR" },
  addedBy: [],
  size: 10,
  from: 0,
  sort: {
    value: "npnt_citation_count",
    label: "Nipt Related Citation"
  }
};

export const mainItems = [
    {
      name: "NON-INVASIVE PRENATAL TESTING",
      value: `"NON-INVASIVE PRENATAL TESTING", "NIPT", "NONINVASIVE PRENATAL TESTING", "NON-INVASIVE PRENATAL SCREENING"`
    },
    {
      name: "CELL FREE DNA",
      value: `"CELL FREE DNA", "CF DNA", "CELL FREE FETAL DNA", "CFF DNA"`
    }
  ];
export const additionalItems = [
    {
      name: "PRENATAL TESTING",
      value: `"PRENATAL TESTING, PRENATAL SCREENING, FIRST TRIMESTER SCREENING, PRENATAL DIAGNOSIS, ANEUPLOIDY SCREENING"`
    },
    {
      name: "ANEUPLOIDY",
      value: `"ANEUPLOIDY"`
    },
    {
      name: "NEWBORN SCREENING",
      value: `"NEWBORN SCREENING"`
    },
  ]

export const appTitle =  "NON-INVASIVE PRENATAL TESTING";